import React from 'react';
import { 
    List, 
    Datagrid,
    TextField, 
    DateField,
    EditButton,
    ShowButton,
    ListButton,
    Show,
    CardActions,
    useQuery, 
    Loading, 
    Error
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import jwt_decode from 'jwt-decode';
import ErrorBoundary from '../ErrorBoundary';


const decoded = (localStorage.token)?jwt_decode(localStorage.token): null
const level = (decoded)? decoded.level: 0


const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};


const coloredStyles = {
    red:    { color: 'red' },
    yellow: { color: 'yellow' },
    blue:   { color: 'blue' },
};



const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};


const ProcessingActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/donors'} label="Donors List" />
    </CardActions>
);

const Editable = ({record}) => {
    //console.log(record.editable);
    return record && record.editable > 0 ? <EditButton  record={record} label='Update'/> : '';
}





export const ProcessingList = ({ classes, permissions, ...props }) => (
    <ErrorBoundary>
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<ProcessingActions/>} 
        title="Schedule / Process / Lab"
        >
        
        <Datagrid  classes={{ headerCell: classes.header }} >
            <TextField source="ssn"     label="SSN" />       
            <TextField source="volume_collected"     label="Collected Volume (ml)" />
            <DateField source="bleed_date"    label="Bleed date" locales="en-us"/>
            <ShowButton lable="View" />
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1  &&
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) != 'PHYN' &&
              <Editable />}
        </Datagrid>
    </List>
    </ErrorBoundary>
);


export default withStyles(listStyles)(ProcessingList)